import $ from 'jquery';

const loader = `<div class="editor-sidebar-loader-absolute spinner-grow" role="status">
    <span class="sr-only">Caricamento...</span>
</div>`;

export const sidebarLoader = (targetId) => {
  $(`#${targetId}`).html(loader);
};
